module.exports = __webpack_public_path__ + "static/honor-3b04e3e44a844689618ba98c895e0bd0.jpg";